module.exports = __webpack_public_path__ + "img/keg.8fddfcd7.png";